import axios from "../api/axios";

export const getHome = async (userId: string, token: string) => {
  const res = await axios.get("home", {
    params: {
      user_id: userId,
    },
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  return res.data.data;
};